module.exports = " <a class=\"fa fa-question-circle popover-help\" v-bind:style=customStyle v-bind:class=class tabindex=0 role=button data-placement={{placement}} data-html=true data-trigger=focus data-container=body title=Help data-content={{{message}}}></a> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ferment/quote.vue
// module id = 450
// module chunks = 2